import { featureFlags } from "./_featureFlags";
import { experience as experienceCore, summary as summaryCore } from "./_experience_core";
import { experience as experienceFe, summary as summaryFe } from "./_experience_fe";

// import { experience as experience_pair_arcus, summary as summary_pair_arcus } from "./experience_pair_arcus";
// import { experience as experience_pair_arcus, summary as summary_pair_arcus } from "./experience_roku";
// import { experience as experience_lseg } from "./experience_lseg";

const experienceVariants = {
  core: experienceCore,
  fe: experienceFe,
};

const summaryVariants = {
  core: summaryCore,
  fe: summaryFe,
};

export { featureFlags };
export const experience = experienceVariants[featureFlags.cvVariant] || experienceCore;
export const summary = summaryVariants[featureFlags.cvVariant] || summaryCore;

// export const experience = experience_pair_arcus
// export const summary = summary_pair_arcus
